import { Component, OnDestroy, OnInit, EventEmitter, Output, ChangeDetectorRef, Input, ViewChild, ElementRef } from '@angular/core';
import { AbstractControl, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { AttachedCompaniesComponent } from './attached-companies/attached-companies.component';
import { MatDialog } from '@angular/material/dialog';
import { SharedService } from 'app/modules/common/services/shared-service';
import { DireccionService } from 'app/modules/employee-view/services/direccion.service';
import { Empresa } from '../models/Empresa/Empresa';
import { DoctorService } from 'app/modules/doctor/services/doctor.service';
import { ConfirmDialogModel } from 'app/modules/common/components/confirmation-dialog/confirm-dialog-model';
import { ConfirmationDialogComponent } from 'app/modules/common/components/confirmation-dialog/confirmation-dialog.component';
import { CompanyManagementViewService } from '../../services/company-management-view.service';
import { EmpresaService } from '../../services/empresa.service';
import { ParentControl } from '../models/Empresa/ParentControl';
import { EmpresaUpdateModel } from '../models/Empresa/EmpresaUpdateModel';
import { comparisonDateValidator, exactLengthValidator, noWhiteSpacesValidator, PostalCodeValidation } from 'app/modules/common/validation/common-validation';
import { CompanySideBarTreeViewService } from '../../services/company-side-bar-tree-view.service';
import * as _ from 'lodash';
import { CurrenyService } from 'app/modules/common/services/curreny.service';
import { PageLoaderService } from 'app/modules/common/services/page-loader.service';

import * as moment from 'moment';
import Utils from 'app/Utils';

@Component({
    selector: 'app-empresa',
    templateUrl: './empresa.component.html',
    styleUrls: ['./empresa.component.scss'],
    standalone: false
})

export class EmpresaComponent implements OnInit, OnDestroy {
  @ViewChild('medicoSelect')doctorSearchInput :ElementRef
  @Output() nodeUpdateEmpresa = new EventEmitter();

  @Input() companyId : any

  public isLoading: boolean = true
  public isEdit: boolean = false;
  public selectedCompanyId: number
  public permissionList = new Array<string>()

  public empresaForm: UntypedFormGroup;
  public datosForm: UntypedFormGroup;

  public adjuntoColumn: string[] = ['company', 'option'];
  public adjuntoDataSource: any[] = null;
  private empresa: Empresa
  private parentControl: ParentControl
  private repercutirList: Array<string>;
  public dropDownList: any = []
  public dropDownFormato: any = []
  _medicoList :any=[];
  public cnaeList: [];
  public sectorList: { viewValue: string }[] = [];
  public finGestión:any;
  public ConvertedFinGestion:any;
  private checkBoxFields =
    [
      'importePorObjetivo',

      'citacionFormal', 'citacionSms','citacionSmsCert',

      'calcularAbsentismo', 'cuadroMando', 'duplicidad', 'movilidad', 'revisar', 'tieneTrabajadores', 'facturacion', 'visitaEmpresa',

      'gestionIt', 'visitasDomiciliarias', 'asistencial', 'noPasanTodasBajas', 'comunicaPostBaja', 'absentismoBajo', 'dispersionGeografica',
      'casosPuntuales', 'actividadPresencialNormal', 'actividadPresencialBaja',

      'contratoRealizado', 'contratoFirmado',

      'fevariable', 'fefijo',

      'listadoPersonal', 'listadoSme', 'listadoJefe', 'solicitarAltas', 'solicitarDirecciones', 'solicitudPlantillas',

      'parentControl', 'ffinContrato', 'referenciaBaja', 'refTrabajador', 'tipoBorrado', 'controlAcumulaciones', 'comentarioParaEmpresa',
      'imprimirNombreLegalEnTareas', 'obligarCitacionTelefonica', 'pamem', 'pes', 'reclamarSolicitud', 'sabadoLaborable', 'seguimientoPostCitacion',
      'sinDatosMedicos', 'tieneSme'
    ];

  constructor
    (
      private _dialog: MatDialog,
      private _sharedService: SharedService,
      private _empresaService: EmpresaService,
      public _fb: UntypedFormBuilder,
      public _direccionService: DireccionService,
      public _doctorService: DoctorService,
      public _companyManagementViewService: CompanyManagementViewService,
      private _companySideBarTreeViewService: CompanySideBarTreeViewService,
      private _currencyService: CurrenyService,
      private cdf: ChangeDetectorRef,
      public pageLoaderService: PageLoaderService,

    ) { 

    //initalize static dropdown lists
    this._empresaService.StaticDropDownList();
    this._empresaService.LoadSectorList();
    //get all dynamic dropdown lists
    this.GetAllDropDownData();
  }

  ngOnInit(): void {    
    this.selectedCompanyId = this.companyId 

    this.isLoading = true
    this.empresa = new Empresa();
    this.parentControl = new ParentControl();
    this.repercutirList = new Array();
    this.isEdit = false;
    const currentUser = JSON.parse(Utils.decrypt(localStorage.getItem('currentUser'))) ;
    if (currentUser) {
      this.permissionList = this._sharedService.getCurrentUserPermissions();
    }

    this.GetEmpresaById(this.selectedCompanyId);
    this.GetGrupoEmpresa(this.selectedCompanyId);
    this.CreateEmpresaForm()
  }

  getProvinciaTooltip(): string {
    const selected = this.empresaForm.get('Provincia').value;
    if (!selected) return '';
    const provincia = this._direccionService.ProvinceList.find(p => p.value === selected);
    return provincia ? provincia.viewValue : '';
  }

  getTipoTooltip(): string {
    const selected = this.empresaForm.get('Tipo').value;
    if (!selected) return '';
    const tipo = this._empresaService.tipoList.find(t => t.value === selected);
    return tipo ? tipo.viewValue : '';
  }
   
  getSectorTooltip(): string {
    const selected = this.empresaForm.get('Sector').value;
    if (!selected) return '';
    const sector = this._empresaService.sectorList.find(s => s.viewValue === selected);
    return sector ? sector.viewValue : '';
  }

  getCNAETooltip(): string {
    const selected = this.empresaForm.get('CNAE').value;
    if (!selected) return '';
    const cnae = this.cnaeList.find(c => (c as any).value === selected) as any;
    return cnae ? `${cnae.value} - ${cnae.stringValue}` : '';
  }

  getCalendarioLaboralTooltip(): string {
    const selected = this.empresaForm.get('CalendarioLaboral').value;
    if (!selected) return '';
    const ccaa = this.dropDownList.ccaa.find(c => c.poblacion === selected);
    return ccaa ? ccaa.poblacion : '';
  }

  getPrimerContactoTooltip(): string {
    const selected = this.empresaForm.get('PrimerContacto').value;
    if (!selected) return '';
    const doctor = this.dropDownList.activeDoctors.find(d => d.value === selected);
    return doctor ? doctor.viewValue : '';
  }

  getMedicoVisitadorTooltip(): string {
    const selected = this.empresaForm.get('MedicoId').value;
    if (!selected) return '';
    const medico = this._medicoList.find(m => m.value === selected);
    return medico ? medico.viewValue : '';
  }

  getPlantillaCitacionTooltip(): string {
    const selected = this.empresaForm.get('CitPlantilla')?.value;
    if (!selected) return '';
    const plantilla = this.dropDownList.plantillaCitacions.find(p => p.viewValue === selected);
    return plantilla ? plantilla.viewValue : '';
  }

  getPlantillaCartaPDTooltip(): string {
    const selected = this.empresaForm.get('CartaPD')?.value;
    if (!selected) return '';
    const plantilla = this.dropDownList.plantillaLOPDs.find(p => p.viewValue === selected);
    return plantilla ? plantilla.viewValue : '';
  }

  getIdiomaSmsTooltip(): string {
    const selected = this.empresaForm.get('IdiomaSms')?.value;
    if (!selected) return '';
    const idioma = this.dropDownList.idiomaSms.find(i => i.viewValue === selected);
    return idioma ? idioma.viewValue : '';
  }

  getConvenioTooltip(): string {
    const selected = this.empresaForm.get('ConvenioId')?.value;
    if (!selected) return '';

    for (const group of this.dropDownList.convenios) {
      const convenio = group.data.find(c => c.convenioId === selected);
      if (convenio) {
        return convenio.nombre;
      }
    }

    return '';
  }

  getAdministrativaTooltip(): string {
    const selected = this.empresaForm.get('DatosHeredados.Administrativa')?.value;
    if (!selected) return '';
    const user = this.dropDownList.activeUsers.find(u => u.stringValue === selected);
    return user ? user.viewValue : '';
  }

  getTareaBajaNuevaTooltip(): string {
    const selected = this.empresaForm.get('DatosHeredados.BajaNueva')?.value;
    if (!selected) return '';
    const baja = this._empresaService.bajaNuevaList.find(b => b.value === selected);
    return baja ? baja.viewValue : '';
  }

  getEnviosTipoTooltip(controlName: string): string {
    const selected = this.empresaForm.get(controlName)?.value;
    if (!selected) return '';
    const envios = this.dropDownList.reportTypes.find(e => e.stringValue === selected);
    return envios ? envios.viewValue : '';
  }

  SearchDoctors()
  {
    const searchInput=this.doctorSearchInput.nativeElement.value ?
      this.doctorSearchInput.nativeElement.value.toLowerCase():'';

    this._medicoList =this.dropDownList.activeDoctors.filter(m=>{
      if(m.viewValue!=null)
      {
      const viewValue : string=m.viewValue.toLowerCase();
      return viewValue.indexOf(searchInput) > -1;
      }
    })
    
  }

  onSectorChange(sector: string): void {
    if (sector) {
      this.LoadCnae(sector); 
    } else {
      this._empresaService.cnaeList = [];  // Vacía la lista si no hay sector seleccionado
    }
  }

  private LoadCnae(sector: string) {
  this._empresaService.LoadCnae(sector).subscribe({
    next: (res) => {
      if (res?.result) {
        this.cnaeList = res.result.map(a => ({
          value: a.value,
          viewValue: a.viewValue,
          stringValue: a.stringValue
        }));
      } else {
        console.warn('No se recibieron datos de CNAE');
        this.cnaeList = [];
      }
    },
    error: (err) => console.error('Error en LoadCnaeList:', err)
  });
}

  public CreateEmpresaForm() {
    this.empresaForm = this._fb.group({
      //#region Empresa
      EmpresaId: [0],
      Nombre: [{ value: '', disabled: true }],
      NombreLegal: [{ value: '', disabled: true }],
      Abreviacion: [{ value: '', disabled: true }],
      Proyecto: [{ value: '', disabled: true }],
      NIF: [{ value: '', disabled: true }],
      Direccion: [{ value: '', disabled: true }],
      CP: [{ value: '', disabled: true }, [PostalCodeValidation(), Validators.pattern('[0-9]*')]],
      Poblacion: [{ value: '', disabled: true }],
      Provincia: [{ value: '', disabled: true }],
      Telefono1: [{ value: '', disabled: true }],
      Fax: [{ value: '', disabled: true }],
      EmailEnvio: [{ value: '', disabled: true }],
      CopiaEnvio: [{ value: '', disabled: true }],
      EmailParte: [{ value: '', disabled: true }],
      //#endregion Empresa

      //#region Datos adicionales
      Tipo: [{ value: '', disabled: true }],
      Sector: [{ value: '', disabled: true }],
      Mutua: [{ value: '', disabled: true }],
      CNAE: [{ value: '', disabled: true }],
      ContingenciasComunes: [{ value: '', disabled: true }],
      ImportePorObjetivo: [{ value: '', disabled: true }],
      //#endregion     

      //#region Datos heredados
      ParentControl: [{ value: '', disabled: true }],
      DatosHeredados: this._fb.group({
        Administrativa: [{ value: '', disabled: true }],
        Coordinador: [{ value: '', disabled: true }],
        TiposBaja: [{ value: '', disabled: true }],
        TiposSinGestion: [{ value: '', disabled: true }],
        TipoDiagnostico: [{ value: '', disabled: true }, Validators.required],
        BajaNueva: [{ value: '', disabled: true }],
        TarifaIndisposicion: [{ value: '', disabled: true }],
        Fantiguedad: [{ value: '', disabled: true }],
        TipoFormatoPersonal: [{ value: '', disabled: true }],
        TipoFormatoSme: [{ value: '', disabled: true }],
        TipoFormatoJefe: [{ value: '', disabled: true }],
        DiasImpedirTareas: [{ value: null, disabled: true }, [Validators.min(0), Validators.max(512)]],
        FfinContrato: [{ value: '', disabled: true }],
        ReferenciaBaja: [{ value: '', disabled: true }],
        RefTrabajador: [{ value: '', disabled: true }],
        TipoBorrado: [{ value: '', disabled: true }],
        ControlAcumulaciones: [{ value: '', disabled: true }],
        ComentarioParaEmpresa: [{ value: '', disabled: true }],
        ImprimirNombreLegalEnTareas: [{ value: '', disabled: true }],
        ObligarCitacionTelefonica: [{ value: '', disabled: true }],
        PAMEM: [{ value: '', disabled: true }],
        PES: [{ value: '', disabled: true }],
        ReclamarSolicitud: [{ value: '', disabled: true }],
        SabadoLaborable: [{ value: '', disabled: true }],
        SeguimientoPostCitacion: [{ value: '', disabled: true }],
        SinDatosMedicos: [{ value: '', disabled: true }],
        TieneSME: [{ value: '', disabled: true }],
      }),
      //#endregion   

      //#region Datos de control
      CalendarioLaboral: [{ value: '', disabled: true }],
      InicioGestion: [{ value: '', disabled: true }],
      FinGestion: [{ value: '', disabled: true }],
      PrimerContacto: [{ value: '', disabled: true }],
      MedicoId: [{ value: '', disabled: true }],
      CitacionFormal: [{ value: '', disabled: true }],
      CitacionSMS: [{ value: '', disabled: true }],
      CitacionSMSCert: [{ value: '', disabled: true }],
      CitPlantilla: [{ value: '', disabled: true }],
      CartaPD: [{ value: '', disabled: true }],
      IdiomaSms: [{ value: '', disabled: true }],
      ConvenioId: [{ value: '', disabled: true }],
      SalarioBruto: [{ value: '', disabled: true }],
      ContingenciasProfesionales: [{ value: '', disabled: true }],
      CalcularAbsentismo: [{ value: '', disabled: true }],
      CuadroMando: [{ value: '', disabled: true }],
      Duplicidad: [{ value: '', disabled: true }],
      Movilidad: [{ value: '', disabled: true }],
      Revisar: [{ value: '', disabled: true }],
      TieneTrabajadores: [{ value: '', disabled: true }],
      Facturacion: [{ value: '', disabled: true }],
      VisitaEmpresa: [{ value: '', disabled: true }],
      //#endregion

      //#region ficha  
      GestionIT: [{ value: '', disabled: true }],
      VisitasDomiciliarias: [{ value: '', disabled: true }],
      Asistencial: [{ value: '', disabled: true }],
      NoPasanTodasBajas: [{ value: '', disabled: true }],
      ComunicaPostBaja: [{ value: '', disabled: true }],
      AbsentismoBajo: [{ value: '', disabled: true }],
      DispersionGeografica: [{ value: '', disabled: true }],
      ActividadFueraContrato: [{ value: '', disabled: true }],
      ObsActividad: [{ value: '', disabled: true }],
      ActividadPresencialNormal: [{ value: '', disabled: true }], //one group
      ActividadPresencialBaja: [{ value: '', disabled: true }],   //one group
      CasosPuntuales: [{ value: '', disabled: true }],            //one group     
      //#endregion

      //#region Facturación
      Fenombre: [{ value: '', disabled: true }],
      FepersonaContacto: [{ value: '', disabled: true }],
      Fetelefono: [{ value: '', disabled: true }],
      Fedireccion: [{ value: '', disabled: true }],
      Fepoblacion: [{ value: '', disabled: true }],
      Fecp: [{ value: '', disabled: true }],
      Fevariable: [{ value: '', disabled: true }],
      Fefijo: [{ value: '', disabled: true }],
      Feimporte: [{ value: '', disabled: true }],
      Feperiodicidad: [{ value: '', disabled: true }],
      FefechaPago: [{ value: '', disabled: true }],
      FediaPago: [{ value: null, disabled: true }, [Validators.min(1), Validators.max(30)]],
      FecodContable: [{ value: '', disabled: true }],
      FecodAnalitico: [{ value: '', disabled: true }],
      Feccentidad: [{ value: '', disabled: true }, exactLengthValidator(4)],
      Feccsucursal: [{ value: '', disabled: true }, exactLengthValidator(4)],
      Feccdc: [{ value: '', disabled: true }, exactLengthValidator(2)],
      Fecccuenta: [{ value: '', disabled: true }, exactLengthValidator(10)],
      Fedestinatario: [{ value: '', disabled: true }],
      CriteriosFacturacion: [{ value: '', disabled: true }],
      //#endregion 

      //#region contrato
      ContratoRealizado: [{ value: '', disabled: true }],
      ContratoFirmado: [{ value: '', disabled: true }],
      FinicioContrato: [{ value: '', disabled: true }],
      DuracionContrato: [{ value: '', disabled: true }],
      FinicioFra: [{ value: '', disabled: true }],
      ProrrogaContrato: [{ value: '', disabled: true }],
      FcontratoEnviado: [{ value: '', disabled: true }],
      FcontratoRecibido: [{ value: '', disabled: true }],
      Comercial: [{ value: '', disabled: true }],
      //#endregion

      //#region
      ListadoPersonal: [{ value: '', disabled: true }],
      ListadoSME: [{ value: '', disabled: true }],
      ListadoJefe: [{ value: '', disabled: true }],
      TipoListadoPersonal: [{ value: '', disabled: true }],
      TipoListadoJefe: [{ value: '', disabled: true }],
      TipoListadoSME: [{ value: '', disabled: true }],
      TipoFormatoPersonal: [{ value: '', disabled: true }],
      TipoFormatoSme: [{ value: '', disabled: true }],
      TipoFormatoJefe: [{ value: '', disabled: true }],
      DirPersonal: [{ value: '', disabled: true }, noWhiteSpacesValidator()],
      DirSME: [{ value: '', disabled: true }, noWhiteSpacesValidator()],
      DirJefe: [{ value: '', disabled: true }, noWhiteSpacesValidator()],
      PasswordPersonal: [{ value: '', disabled: true }],
      PasswordSME: [{ value: '', disabled: true }],
      PasswordJefe: [{ value: '', disabled: true }],
      SolicitarAltas: [{ value: '', disabled: true }],
      SolicitarDirecciones: [{ value: '', disabled: true }],
      SolicitudPlantillas: [{ value: '', disabled: true }],
      EmailAltas: [{ value: '', disabled: true }],
      PasswordAlta: [{ value: '', disabled: true }],
      EmailPlantillas: [{ value: '', disabled: true }],
      //#endregion

      Observaciones: [{ value: '', disabled: true }]

    })

    this.datosForm = this.empresaForm.get("DatosHeredados") as UntypedFormGroup;
    this.empresaForm.setValidators([comparisonDateValidator('InicioGestion', 'FinGestion')])
  }

  public checkPermisionVisibility(visibility: string) {
    return this.permissionList.includes(visibility)
  }

  public checkPermisionReadonly(control: AbstractControl) {
    //get user define permission property  
    let permissionId = control['readonlyPermissionId']

    //enable if that field has permission
    if (permissionId != undefined && !this.permissionList.includes(permissionId)) {
      control.disable()
    } else {
      control.enable()
    }
  }

  public DisableSms(tipo :string){

    if(tipo == 'cert'){
      this.empresaForm.get('CitacionSMS').setValue(true);
    }
    if (this.empresaForm.get('CitacionSMS').value == false) {
      this.empresaForm.get('CitacionSMSCert').setValue(false);
    }


    // if(tipo == 'cert'){
    //   this.empresaForm.get('CitacionSMS').setValue(false);
    // }else{
    //   this.empresaForm.get('CitacionSMSCert').setValue(false);
    // }
  }

  public EnableFormFields(isEdit: boolean) {
    //set permissions to form controls
    this.ngAfterViewInit()
    //toggle adjuntos   
    this.isEdit = isEdit
    if (isEdit) {
      for (const field in this.empresaForm.controls) {

        if (this.empresaForm.get(field) instanceof UntypedFormGroup) {
          const control = this.datosForm.get(field);
          if (control != null) this.checkPermisionReadonly(control)
        } else {
          const control = this.empresaForm.get(field);
          if (control != null) this.checkPermisionReadonly(control)
        }
      }
      //if its checked these fields cannot edit and it should be disabled
      let isParentControl = this.empresaForm.get('ParentControl');
      if (!isParentControl.value && this.permissionList.includes(isParentControl['readonlyPermissionId'])) this.datosForm.enable()

    } else {
      this.DisableForms()
    }
  }

  public EnableOrDisableParentControlFormFields(checkbox) {
    if (checkbox.checked) {
      //Get parent data and disable the fields
      this.GetParentValues()
      this.datosForm.disable()
    } else {
      this.datosForm.enable()
    }
  }

  public GetEmpresaById(companyId: any) {
    this._empresaService.GetEmpresaById(companyId)
      .subscribe(res => {
        if (res.result) {
          this.empresa = res.result
          this.finGestión=res.result.finGestion;
          this.SetFormValues();
          this.LoadCnae(res.result.sector);
        }
      });
  }

  private SetFormValues() {
    this.isLoading = true;
    this.setFormData(this.empresaForm);

    //untill all the data is bind hide the form
    this.isLoading = false;
  }
  
  private setFormData(fg: UntypedFormGroup) {
    for (const field in fg.controls) {

      let fieldtemp = this.GetObjectName(field);
      let value = this.empresa[fieldtemp];

      //converting to char array for mutiple select checkbox dropdown        
      if ((field == "TiposBaja" || field == "TiposSinGestion") && this.empresa[fieldtemp] != null) {
        value = this.empresa[fieldtemp].split('');
      }

      //Convert S/N value to true/false  
      if (this.checkBoxFields.includes(fieldtemp)) {
        value = this.empresa[fieldtemp] === 'S'
        //this field has an integer instead of S/N
        if (field == "TipoBorrado")
          value = this.empresa[fieldtemp] === 1
      }

      if (field == "SalarioBruto" || field == "ContingenciasProfesionales" || field == "Feimporte") {
        //converts number to spanish formart
        value = this.empresa[fieldtemp] ? this._currencyService.setSpanishCurreny(this.empresa[fieldtemp].toString()) : null;
      }

      if (fg.get(field) instanceof UntypedFormGroup) {
        this.setFormData(fg.get(field) as UntypedFormGroup);
      } else {
        fg.get(field).patchValue(value);
      }
    }
  }

  private GetObjectName(fieldName: string) {
    if (fieldName == "FAntiguedad") {
      return fieldName = "fantiguedad"
    }
    return _.camelCase(fieldName);
  }

  private GetAllDropDownData() {
    this._empresaService.GetAllDropDownData()
      .subscribe(res => {        
        this.dropDownList = res.result;
        this._medicoList=this.dropDownList.activeDoctors;
        //sort values for group dropdown selector
        this.dropDownList.convenios = this.groupBy(res.result.convenios, 'grupo')
        this.dropDownList.convenios = Object.keys(this.dropDownList.convenios).map((key) => {
          var a = {
            name: key,
            data: this.dropDownList.convenios[key]
          }
          return a;
        });
      });
  }

  private groupBy = (items, key) => items.reduce(
    (result, item) => ({
      ...result,
      [item[key]]: [
        ...(result[item[key]] || []),
        item,
      ],
    }),
    {},
  )

  private GetParentValues() {
    this._empresaService.GetParentControls(this.selectedCompanyId)
      .subscribe(res => {
        this.parentControl = res.result
        for (const field in this.datosForm.controls) {
          let fieldtemp = this.GetObjectName(field);

          if (this.parentControl[fieldtemp] != null) {
            let value = this.parentControl[fieldtemp];
            //converting to char array for mutiple select checkbox dropdown
            if ((field == "TiposBaja" || field == "TiposSinGestion") && this.parentControl[fieldtemp] != null) {
              value = this.parentControl[fieldtemp].split('');
            }
            //Convert S/N value to true/false  
            if (this.checkBoxFields.includes(fieldtemp)) {

              value = this.parentControl[fieldtemp] === 'S'
              //this field has an integer instead of S/N
              if (field == "TipoBorrado")
                value = this.parentControl[fieldtemp] === 1
            }
            this.datosForm.get(field).patchValue(value);
          } else {
            this.datosForm.get(field).patchValue("");
          }
        }
      });
  }

  public CreateCompany(): void {
    const dialogRef = this._dialog.open(AttachedCompaniesComponent, {
      data: { companyList: this.adjuntoDataSource, padreId: this.selectedCompanyId }
    });
    dialogRef.afterClosed().subscribe(response => {
      if (response) this.GetGrupoEmpresa(this.selectedCompanyId)
    });
  }

  public DeleteCompany(element) {
    const dialogData = new ConfirmDialogModel('¿Quitar la empresa adjuntada?', '');
    const dialogRef = this._dialog.open(ConfirmationDialogComponent, {
      data: dialogData
    });

    dialogRef.afterClosed().subscribe(responce => {
      if (responce) {
        this._empresaService.DeleteAdjuntos(this.selectedCompanyId, element.empresaId).subscribe(result => {
          if (result) {
            this._sharedService.ShowSnackBar('Borrado exitosamente', 'Okay', 2000);
          } else {
            this._sharedService.ShowSnackBar('Error al eliminar', 'Okay', 2000);
          }
        }, err => {
          this._sharedService.ShowSnackBar('Se produjo un error', 'Okay', 2000);
        });
      }
    }
    )
  }

  public GetGrupoEmpresa(companyId) {
    this._empresaService.GetGrupoEmpresa(companyId)
      .subscribe(res => {
        this.adjuntoDataSource = res.result
      });
  }

  public CheckBoxChange(selected) {
    if ('ActividadPresencialNormal' === selected) {
      this.empresaForm.get(selected).setValue(true);
      this.empresaForm.get('ActividadPresencialBaja').setValue(false);
      this.empresaForm.get('CasosPuntuales').setValue(false);
    } else if ('ActividadPresencialBaja' === selected) {
      this.empresaForm.get(selected).setValue(true);
      this.empresaForm.get('ActividadPresencialNormal').setValue(false);
      this.empresaForm.get('CasosPuntuales').setValue(false);
    } else if ('CasosPuntuales' === selected) {
      this.empresaForm.get(selected).setValue(true);
      this.empresaForm.get('ActividadPresencialNormal').setValue(false);
      this.empresaForm.get('ActividadPresencialBaja').setValue(false);
    }
  }

  public CopyEmpresaValues() {
    //copying values from empreasa to fratuation values
    this.empresaForm.get('Fenombre').setValue(this.empresaForm.get('Nombre').value);
    this.empresaForm.get('Fedireccion').setValue(this.empresaForm.get('Direccion').value);
    this.empresaForm.get('Fecp').setValue(this.empresaForm.get('CP').value);
    this.empresaForm.get('Fepoblacion').setValue(this.empresaForm.get('Poblacion').value);
    this.empresaForm.get('Fetelefono').setValue(this.empresaForm.get('Telefono1').value);
  }

  public AddRepercutirFields(fieldName: string) {
    //creates repecutir list to update later
    const dialogData = new ConfirmDialogModel('¿Repercutir este campo a todas las empresas de niveles inferiores?', '');
    const dialogRef = this._dialog.open(ConfirmationDialogComponent, {
      data: dialogData
    });

    dialogRef.afterClosed().subscribe(responce => {
      if (responce) {
        if (fieldName === "CitacionSMSCert"){
          if (!this.repercutirList.includes("CitacionSMSCert"))
            this.repercutirList.push("CitacionSMSCert");

          if (!this.repercutirList.includes("CitacionSMS"))
            this.repercutirList.push("CitacionSMS");
        }else{
          if (!this.repercutirList.includes(fieldName))
            this.repercutirList.push(fieldName);
        }
        
      }
    }
    )
  }

  private ConvertFormToObject(empresa): any {
    this.getFormData(this.empresaForm, empresa);
    return empresa;
  }

  private getFormData(fg: UntypedFormGroup, empresa: any) {
    for (const field in fg.controls) {
      const control = fg.get(field);
      let fieldtemp = this.GetObjectName(field);

      if (fg.get(field) instanceof UntypedFormGroup) {
        this.getFormData(fg.get(field) as UntypedFormGroup, empresa);
      } else {
        if (this.checkBoxFields.includes(fieldtemp)) {
          empresa[fieldtemp] = (control.value === true) ? "S" : "N";
          if (field === "TipoBorrado") {
            empresa[fieldtemp] = control.value ? 1 : 0
          }
        }
        else if (field === "TiposBaja" || field === "TiposSinGestion") {
          empresa[fieldtemp] = control.value != null ? control.value.toString().replace(/[^\w\s]/g, '') : null
        } else if (field == "SalarioBruto" || field == "ContingenciasProfesionales" || field == "Feimporte") {
          empresa[fieldtemp] = control.value != null ? this._currencyService.replaceSpanishFormat(control.value) : null
        }
        else {
          empresa[fieldtemp] = control.value
        }
      }
    }
  }

  public  formatDate(date: any): string {
    if (date === undefined || date === null) {
      return undefined;
    } else {
      //const adjustedDate = this.adjustToLocalDate(date);
        return moment(date).format('YYYY-MM-DD');
    }
  }

    adjustToLocalDate(date: any): Date {
      const selectedDate = new Date(date);
      return new Date(Date.UTC(selectedDate.getFullYear(), selectedDate.getMonth(), selectedDate.getDate()));
  }
 

  adjustDateRec(date: any) {
    if(date == null || date == undefined) {
      this.empresaForm.get('FcontratoRecibido').setValue(null);
    }else{
      const adjustedDate = this.adjustToLocalDate(date);
      this.empresaForm.get('FcontratoRecibido').setValue(adjustedDate);
    }

  }
  adjustDateEnv(date: any) {
    if(date == null || date == undefined){
      this.empresaForm.get('FcontratoEnviado').setValue(null);
    }else{
      const adjustedDate = this.adjustToLocalDate(date);
      this.empresaForm.get('FcontratoEnviado').setValue(adjustedDate);
    }
  }
  
  public Submit() {
    this.empresaForm.markAllAsTouched();
    this.empresaForm.updateValueAndValidity();

    if (this.GetFormValidity()) {
      
      //FinGestion validation and staff closing function
      if(this.empresaForm.get('FinGestion').value!=null || this.empresaForm.get('FinGestion').value=='')
      {
        this.finGestión==null ? null :this.finGestión=this.finGestión.split('T')[0];

        this.ConvertedFinGestion=this.empresaForm.get('FinGestion').value;

        if(this.ConvertedFinGestion._isAMomentObject)
        {
          this.ConvertedFinGestion=this.empresaForm.get('FinGestion').value.format("YYYY-MM-DD");
        }else {
          let value =this.empresaForm.get('FinGestion').value;
          this.ConvertedFinGestion=value.split('T')[0];
        }

        if(this.finGestión!=this.ConvertedFinGestion)
        {
            const dialogData = new ConfirmDialogModel('Se ha introducido la fecha de fin de gestión. ¿Poner a 0 las plantillas de esta empresa y de niveles inferiores en el mes de cierre?', '');
            const dialogRef = this._dialog.open(ConfirmationDialogComponent, {
              data: dialogData
            });
            dialogRef.afterClosed().subscribe(response => {
              if(response)
              {
                this.pageLoaderService.ShowPageLoader();
                this._empresaService.closingStaff(this.companyId,this.ConvertedFinGestion).subscribe(res=> {
                  this.isLoading=true;
                  if(res.result==true)
                  {
                    this.updateEmpresa(false);
                     this._sharedService.ShowSnackBar('Plantillas puestas a 0 correctamente', 'Okay', 4000);
                    this.pageLoaderService.HidePageLoader();
                    this.isLoading=false;
                  }else {
                    this.pageLoaderService.HidePageLoader();
                    this.isLoading=false;
                    this._sharedService.ShowSnackBar('Error al guardar', 'Okay', 2000);
                  }
                });
              }else {
                this.updateEmpresa(true);
              }
            });  
        }else {
          this.updateEmpresa(true);
        }
      }else {
        this.updateEmpresa(true);
      }
    }
  }

  updateEmpresa(message:boolean)
  {
    this.ConvertFormToObject(this.empresa)

      const updateModel = new EmpresaUpdateModel()

      updateModel.Empresa = this.empresa
      updateModel.RepercutirList = this.repercutirList
      
      updateModel.Empresa.InicioGestion = this.formatDate(this.empresaForm.get('InicioGestion').value);
      updateModel.Empresa.FinGestion = this.formatDate(this.empresaForm.get('FinGestion').value);

      this._empresaService.UpdateEmpresa(updateModel)

        .subscribe(res => {
          if (res.code === 0 && res.result === 1) {

            this.nodeUpdateEmpresa.emit(this.empresa);
            this.empresa = null
            this.DisableForms()
            this.GetEmpresaById(this.selectedCompanyId);
            this.EnableFormFields(false)
           // this._companySideBarTreeViewService.changeCompanyEmpresaName(this.empresaForm.get('Nombre').value)
           // this._companySideBarTreeViewService.changecreatedCompanyName(this.empresaForm.get('EmpresaId').value)
           if(message)
           {
            this._sharedService.ShowSnackBar('Actualizado con éxito', 'Okay', 2000);
           }
           
          } else {
            this._sharedService.ShowSnackBar('Error al guardar', 'Okay', 2000);
          }
        }, err => {
          this._sharedService.ShowSnackBar('Se produjo un error', 'Okay', 2000);
        })
  }

  //This method is accessed in company-view-detail.component
  public GetFormValidity(): boolean {
    return this.empresaForm.valid
  }

  public DisableForms(): void {
    this.empresaForm.disable()
    this.datosForm.disable()
  }

  ngAfterViewInit() {
    //set permision for each field

    //#region Empresa
    this.empresaForm.get('Nombre')['readonlyPermissionId'] = '4';
    this.empresaForm.get('NombreLegal')['readonlyPermissionId'] = '4';
    this.empresaForm.get('Abreviacion')['readonlyPermissionId'] = '4';
    this.empresaForm.get('Proyecto')['readonlyPermissionId'] = '4';
    this.empresaForm.get('NIF')['readonlyPermissionId'] = '4';
    this.empresaForm.get('Direccion')['readonlyPermissionId'] = '4';
    this.empresaForm.get('CP')['readonlyPermissionId'] = '4';
    this.empresaForm.get('Poblacion')['readonlyPermissionId'] = '4';
    this.empresaForm.get('Provincia')['readonlyPermissionId'] = '4';
    this.empresaForm.get('Telefono1')['readonlyPermissionId'] = '4';
    this.empresaForm.get('Fax')['readonlyPermissionId'] = '4';
    this.empresaForm.get('EmailEnvio')['readonlyPermissionId'] = '4';
    this.empresaForm.get('CopiaEnvio')['readonlyPermissionId'] = '4';
    this.empresaForm.get('EmailParte')['readonlyPermissionId'] = '4';
    //#endregion

    //#region Datos adicionales
    this.empresaForm.get('Tipo')['readonlyPermissionId'] = '4';
    this.empresaForm.get('Sector')['readonlyPermissionId'] = '4';
    this.empresaForm.get('Mutua')['readonlyPermissionId'] = '4';
    this.empresaForm.get('CNAE')['readonlyPermissionId'] = '4';
    this.empresaForm.get('ContingenciasComunes')['readonlyPermissionId'] = '4';
    this.empresaForm.get('ImportePorObjetivo')['readonlyPermissionId'] = '4';
    //#endregion

    //#region Datos de control
    this.empresaForm.get('CalendarioLaboral')['readonlyPermissionId'] = '38';
    this.empresaForm.get('InicioGestion')['readonlyPermissionId'] = '38';
    this.empresaForm.get('FinGestion')['readonlyPermissionId'] = '38';
    this.empresaForm.get('PrimerContacto')['readonlyPermissionId'] = '38';
    this.empresaForm.get('MedicoId')['readonlyPermissionId'] = '38';
    this.empresaForm.get('CitacionFormal')['readonlyPermissionId'] = '38';
    this.empresaForm.get('CitacionSMS')['readonlyPermissionId'] = '38';
    this.empresaForm.get('CitacionSMSCert')['readonlyPermissionId'] = '38';
    this.empresaForm.get('CitPlantilla')['readonlyPermissionId'] = '38';
    this.empresaForm.get('CartaPD')['readonlyPermissionId'] = '38';
    this.empresaForm.get('IdiomaSms')['readonlyPermissionId'] = '38';
    this.empresaForm.get('ConvenioId')['readonlyPermissionId'] = '38';
    this.empresaForm.get('SalarioBruto')['readonlyPermissionId'] = '38';
    this.empresaForm.get('ContingenciasProfesionales')['readonlyPermissionId'] = '38';
    this.empresaForm.get('CalcularAbsentismo')['readonlyPermissionId'] = '38';
    this.empresaForm.get('CuadroMando')['readonlyPermissionId'] = '38';
    this.empresaForm.get('Duplicidad')['readonlyPermissionId'] = '38';
    this.empresaForm.get('Movilidad')['readonlyPermissionId'] = '38';
    this.empresaForm.get('Revisar')['readonlyPermissionId'] = '38';
    this.empresaForm.get('TieneTrabajadores')['readonlyPermissionId'] = '38';
    this.empresaForm.get('Facturacion')['readonlyPermissionId'] = '38';
    this.empresaForm.get('VisitaEmpresa')['readonlyPermissionId'] = '38';
    //#endregion

    //#region Datos Heredados
    this.empresaForm.get('ParentControl')['readonlyPermissionId'] = '38';
    this.datosForm.get('Administrativa')['readonlyPermissionId'] = '38';
    this.datosForm.get('Coordinador')['readonlyPermissionId'] = '38';
    this.datosForm.get('TiposBaja')['readonlyPermissionId'] = '38';
    this.datosForm.get('TiposSinGestion')['readonlyPermissionId'] = '38';
    this.datosForm.get('TipoDiagnostico')['readonlyPermissionId'] = '38';
    this.datosForm.get('BajaNueva')['readonlyPermissionId'] = '38';
    this.datosForm.get('TarifaIndisposicion')['readonlyPermissionId'] = '38';
    this.datosForm.get('Fantiguedad')['readonlyPermissionId'] = '38';
    this.datosForm.get('DiasImpedirTareas')['readonlyPermissionId'] = '38';
    this.datosForm.get('FfinContrato')['readonlyPermissionId'] = '38';
    this.datosForm.get('ReferenciaBaja')['readonlyPermissionId'] = '38';
    this.datosForm.get('RefTrabajador')['readonlyPermissionId'] = '38';
    this.datosForm.get('TipoBorrado')['readonlyPermissionId'] = '38';
    this.datosForm.get('ControlAcumulaciones')['readonlyPermissionId'] = '38';
    this.datosForm.get('ComentarioParaEmpresa')['readonlyPermissionId'] = '38';
    this.datosForm.get('ImprimirNombreLegalEnTareas')['readonlyPermissionId'] = '38';
    this.datosForm.get('ObligarCitacionTelefonica')['readonlyPermissionId'] = '38';
    this.datosForm.get('PAMEM')['readonlyPermissionId'] = '38';
    this.datosForm.get('PES')['readonlyPermissionId'] = '38';
    this.datosForm.get('ReclamarSolicitud')['readonlyPermissionId'] = '38';
    this.datosForm.get('SabadoLaborable')['readonlyPermissionId'] = '38';
    this.datosForm.get('SeguimientoPostCitacion')['readonlyPermissionId'] = '38';
    this.datosForm.get('SinDatosMedicos')['readonlyPermissionId'] = '38';
    this.datosForm.get('TieneSME')['readonlyPermissionId'] = '38';
    //#endregion

    //#region Ficha
    this.empresaForm.get('GestionIT')['readonlyPermissionId'] = '4';
    this.empresaForm.get('VisitasDomiciliarias')['readonlyPermissionId'] = '4';
    this.empresaForm.get('Asistencial')['readonlyPermissionId'] = '4';
    this.empresaForm.get('NoPasanTodasBajas')['readonlyPermissionId'] = '4';
    this.empresaForm.get('ComunicaPostBaja')['readonlyPermissionId'] = '4';
    this.empresaForm.get('AbsentismoBajo')['readonlyPermissionId'] = '4';
    this.empresaForm.get('DispersionGeografica')['readonlyPermissionId'] = '4';
    this.empresaForm.get('ActividadFueraContrato')['readonlyPermissionId'] = '4';
    this.empresaForm.get('ObsActividad')['readonlyPermissionId'] = '4';
    this.empresaForm.get('ActividadPresencialNormal')['readonlyPermissionId'] = '4';
    this.empresaForm.get('ActividadPresencialBaja')['readonlyPermissionId'] = '4';
    this.empresaForm.get('CasosPuntuales')['readonlyPermissionId'] = '4';
    //#endregion

    //#region Facturación
    this.empresaForm.get('Fenombre')['readonlyPermissionId'] = '39';
    this.empresaForm.get('FepersonaContacto')['readonlyPermissionId'] = '39';
    this.empresaForm.get('Fetelefono')['readonlyPermissionId'] = '39';
    this.empresaForm.get('Fedireccion')['readonlyPermissionId'] = '39';
    this.empresaForm.get('Fepoblacion')['readonlyPermissionId'] = '39';
    this.empresaForm.get('Fecp')['readonlyPermissionId'] = '39';
    this.empresaForm.get('Fevariable')['readonlyPermissionId'] = '39';
    this.empresaForm.get('Fefijo')['readonlyPermissionId'] = '39';
    this.empresaForm.get('Feimporte')['readonlyPermissionId'] = '39';
    this.empresaForm.get('Feperiodicidad')['readonlyPermissionId'] = '39';
    this.empresaForm.get('FefechaPago')['readonlyPermissionId'] = '39';
    this.empresaForm.get('FediaPago')['readonlyPermissionId'] = '39';
    this.empresaForm.get('FecodContable')['readonlyPermissionId'] = '39';
    this.empresaForm.get('FecodAnalitico')['readonlyPermissionId'] = '39';
    this.empresaForm.get('Feccentidad')['readonlyPermissionId'] = '39';
    this.empresaForm.get('Feccsucursal')['readonlyPermissionId'] = '39';
    this.empresaForm.get('Feccdc')['readonlyPermissionId'] = '39';
    this.empresaForm.get('Fecccuenta')['readonlyPermissionId'] = '39';
    this.empresaForm.get('Fedestinatario')['readonlyPermissionId'] = '39';
    this.empresaForm.get('CriteriosFacturacion')['readonlyPermissionId'] = '39';
    //#endregion

    //#region contrato
    this.empresaForm.get('ContratoRealizado')['readonlyPermissionId'] = '39';
    this.empresaForm.get('ContratoFirmado')['readonlyPermissionId'] = '39';
    this.empresaForm.get('FinicioContrato')['readonlyPermissionId'] = '39';
    this.empresaForm.get('DuracionContrato')['readonlyPermissionId'] = '39';
    this.empresaForm.get('FinicioFra')['readonlyPermissionId'] = '39';
    this.empresaForm.get('ProrrogaContrato')['readonlyPermissionId'] = '39';
    this.empresaForm.get('FcontratoEnviado')['readonlyPermissionId'] = '39';
    this.empresaForm.get('FcontratoRecibido')['readonlyPermissionId'] = '39';
    this.empresaForm.get('Comercial')['readonlyPermissionId'] = '39';
    //#endregion

    //#region nvíos automáticos
    this.empresaForm.get('ListadoPersonal')['readonlyPermissionId'] = '38';
    this.empresaForm.get('ListadoSME')['readonlyPermissionId'] = '38';
    this.empresaForm.get('ListadoJefe')['readonlyPermissionId'] = '38';
    this.empresaForm.get('TipoListadoPersonal')['readonlyPermissionId'] = '38';
    this.empresaForm.get('TipoListadoJefe')['readonlyPermissionId'] = '38';
    this.empresaForm.get('TipoListadoSME')['readonlyPermissionId'] = '38';
    this.empresaForm.get('DirPersonal')['readonlyPermissionId'] = '38';
    this.empresaForm.get('DirSME')['readonlyPermissionId'] = '38';
    this.empresaForm.get('DirJefe')['readonlyPermissionId'] = '38';
    this.empresaForm.get('PasswordPersonal')['readonlyPermissionId'] = '38';
    this.empresaForm.get('PasswordSME')['readonlyPermissionId'] = '38';
    this.empresaForm.get('PasswordJefe')['readonlyPermissionId'] = '38';
    this.empresaForm.get('SolicitarAltas')['readonlyPermissionId'] = '38';
    this.empresaForm.get('SolicitarDirecciones')['readonlyPermissionId'] = '38';
    this.empresaForm.get('SolicitudPlantillas')['readonlyPermissionId'] = '38';
    this.empresaForm.get('EmailAltas')['readonlyPermissionId'] = '38';
    this.empresaForm.get('PasswordAlta')['readonlyPermissionId'] = '38';
    this.empresaForm.get('EmailPlantillas')['readonlyPermissionId'] = '38';
    //#endregion


  }

  ngOnDestroy() {
  }

}
